import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";
import DashboardLayout from "../../../shared/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../shared/Navbars/DashboardNavbar";
import Footer from "../../../shared/Footer";
import DataTable from "../../../shared/Tables/DataTable";
import adService from "../../../services/adService";
import ActionCell from "./components/ActionCell";
import MDBadge from "../../../components/MDBadge";
import MDSnackbar from "../../../components/MDSnackbar";
import { formatDate } from "../../../utils/formatDate";

function AdList() {
  const [ads, setAds] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const [notification, setNotification] = useState({
    open: false,
    color: "info",
    title: "",
    message: "",
  });

  useEffect(() => {
    fetchAds(page, limit, search);
  }, [page, limit, search]);

  const fetchAds = async (currentPage, currentLimit, currentSearch) => {
    setLoading(true);
    try {
      const response = await adService.getAll({
        page: currentPage + 1,
        limit: currentLimit,
        q: currentSearch,
        searchFields: "title,section,url",
        select: "title,section,url,clicks,startDate,endDate,status"
      });
      setAds(response.data || []);
      setTotalCount(response.total || 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching ads:", error);
      setLoading(false);
    }
  };

  const getStatusDisplay = (ad) => {
    const now = new Date();
    const endDate = new Date(ad.endDate);
    
    if (ad.status === "inactivo") return "Inactivo";
    if (now > endDate) return "Expirado";
    return "Activo";
  };

  const getStatusColor = (statusDisplay) => {
    if (statusDisplay === "Activo") return "success";
    if (statusDisplay === "Expirado") return "warning";
    return "secondary";
  };

  const columns = [
    { Header: "Título", accessor: "title", align: "left" },
    { Header: "Sección", accessor: "section", align: "left" },
    { Header: "URL", accessor: "url", align: "left" },
    { Header: "Clicks", accessor: "clicks", align: "left" },
    { Header: "Inicio", accessor: "startDate", align: "left" },
    { Header: "Finalización", accessor: "endDate", align: "left" },
    { Header: "Estado", accessor: "status", align: "left" },
    { Header: "Acciones", accessor: "actions", align: "center" },
  ];

  const rows = ads.map((ad) => ({
    title: <MDTypography variant="button" fontWeight="medium">{ad.title}</MDTypography>,
    section: <MDTypography variant="caption">{ad.section}</MDTypography>,
    url: <MDTypography variant="caption">{ad.url}</MDTypography>,
    clicks: <MDTypography variant="caption">{ad.clicks}</MDTypography>,
    startDate: <MDTypography variant="caption">{formatDate(ad.startDate)}</MDTypography>,
    endDate: <MDTypography variant="caption">{formatDate(ad.endDate)}</MDTypography>,
    status: <MDBadge badgeContent={getStatusDisplay(ad)} color={getStatusColor(getStatusDisplay(ad))} variant="gradient" size="sm" />,
    actions: (
      <MDBox display="flex" alignItems="center">
        <ActionCell id={ad._id} action="details" icon="visibility" color="info" />
        <ActionCell id={ad._id} action="edit" icon="edit" color="info" />
        <ActionCell id={ad._id} action="delete" icon="delete" color="primary" onDelete={fetchAds} />
      </MDBox>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
      >
        <MDButton
          component={Link}
          to="/ads/new"
          variant="gradient"
          color="info"
        >
          Nuevo
        </MDButton>
      </MDBox>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h6" color="white">Anuncios</MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={{ defaultValue: limit, entries: [5, 10, 15, 20, 25] }}
                  showTotalEntries={true}
                  noEndBorder
                  canSearch={true}
                  isManualPagination={true}
                  pageCount={Math.ceil(totalCount / limit)}
                  onPageChange={(newPage) => setPage(newPage)}
                  onPageSizeChange={(newLimit) => setLimit(newLimit)}
                  onSearchChange={(newSearch) => {
                    setSearch(newSearch);
                    setPage(0);
                  }}
                  totalEntries={totalCount}
                  loading={loading}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <MDSnackbar
        color={notification.color}
        icon={notification.icon}
        title={notification.title}
        content={notification.message}
        open={notification.open}
        close={() => setNotification({ ...notification, open: false })}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default AdList;